import {Component} from "react";
import {Link} from "react-router-dom";

class BPUserRow extends Component{
    constructor(props) {
        super(props);
    }
    componentDidMount() {
    }
    render() {
        const {index,item} = this.props;
        return(
            <tr>
                <td>{index+1}</td>
                <td>{item?.username}</td>
                <td>{item?.branchCode}</td>
                <td>{item?.email}</td>
                <td>{item?.bankCode}</td>
                <td><Link to={'/bp/user/edit/'+item?.username} className={'badge badge-info even-larger-badge'}>Thay đổi thông tin</Link></td>
            </tr>
        )
    }
}
export default BPUserRow